import { useQuery } from "@tanstack/react-query";

import { useAuth, authorizedAxios, TaxType, CapitalTerm } from "@moonscape/shared";

export const useTaxEventsData = ({
  page,
  taxYear,
  taxType = TaxType.CAPITAL_GAIN,
  capitalTerm = CapitalTerm.ALL,
  searchQuery = "",
  versionId,
  onLoading,
}: {
  page: number;
  taxYear: number;
  taxType?: string;
  capitalTerm?: string;
  searchQuery?: string;
  versionId?: number | null;
  onLoading?: (loading: boolean) => void;
}) => {
  const { getToken, user } = useAuth();

  // userId
  const email = user?.email;

  console.log("[cc] email", email);

  console.log("useTaxEventsData-page", page, "searchQuery", searchQuery);

  const getTaxEventsData = async () => {
    try {
      const token = await getToken();
      let url = `/tax/v2/events/${taxYear}?cursor=${page}&limit=20&taxType=${taxType}&capitalTerm=${capitalTerm}`;

      // Add search query if provided
      if (searchQuery && searchQuery.trim()) {
        url += `&search=${encodeURIComponent(searchQuery.trim())}`;
      }

      // Add version filter if provided
      if (versionId) {
        url += `&versionId=${versionId}`;
      }

      console.log("tax events url: ", url);
      const res = await authorizedAxios(token).get(url);
      console.log("useTaxEventsData() url ", url);

      console.log("/trades res", res.data, user?.email);
      return res.data;
    } catch (error) {
      console.log("[useTaxEventsData] error ", JSON.stringify(error, null, 2));
      return { error };
    }
  };

  const useQueryKey = `tax-events`;

  const {
    isLoading: isQueryLoading,
    isSuccess,
    isIdle,
    error,
    isError,
    data: taxEvents,
    isPreviousData,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: [useQueryKey, page, taxYear, taxType, capitalTerm, searchQuery, versionId],
    queryFn: getTaxEventsData,

    // The query will not execute until the userId exists
    enabled: !!email,

    keepPreviousData: true,
  });
  // isSearching && isFetching ? onLoading(isFetching) : onLoading(false);

  return { isQueryLoading, isIdle, error, taxEvents, isPreviousData, refetch };
};
